// Accent palettes. HQ and public LXNWRLD are stored and applied separately.
export const PRESETS = [
  ["Crimson", "#E53935"], ["Scarlet", "#FF3B30"], ["Ruby", "#C2185B"], ["Rose", "#F43F5E"],
  ["Coral", "#FF6F61"], ["Orange", "#F97316"], ["Amber", "#F59E0B"], ["Gold", "#EAB308"],
  ["Lime", "#84CC16"], ["Emerald", "#10B981"], ["Teal", "#14B8A6"], ["Cyan", "#06B6D4"],
  ["Sky", "#0EA5E9"], ["Blue", "#3B82F6"], ["Indigo", "#6366F1"], ["Violet", "#7C3AED"],
  ["Purple", "#A855F7"], ["Fuchsia", "#D946EF"], ["Pink", "#EC4899"], ["Silver", "#A1A1AA"],
];
export const DEFAULT_HQ = "#E53935";
export const DEFAULT_WRLD = "#7C3AED";
const HQ_KEY = "lxn_hq_accent";
const STEPS = { 50: [1, 0.93], 100: [1, 0.85], 200: [1, 0.7], 300: [1, 0.5], 400: [1, 0.3], 500: [1, 0.15], 600: [0, 0], 700: [0, 0.15], 800: [0, 0.3], 900: [0, 0.45], 950: [0, 0.65] };

function rgbOf(hex) { const n = parseInt(hex.slice(1), 16); return [(n >> 16) & 255, (n >> 8) & 255, n & 255]; }
export const isHex = (v) => /^#[0-9A-Fa-f]{6}$/.test(v || "");
function luminance(hex) {
  const [r, g, b] = rgbOf(hex).map((v) => { const c = v / 255; return c <= 0.03928 ? c / 12.92 : ((c + 0.055) / 1.055) ** 2.4; });
  return 0.2126 * r + 0.7152 * g + 0.0722 * b;
}
// WCAG contrast of the accent against the black public background.
export const contrastOnBlack = (hex) => (luminance(hex) + 0.05) / 0.05;
// Text color that stays readable on top of a solid accent button.
export const inkFor = (hex) => (luminance(hex) > 0.4 ? "0 0 0" : "255 255 255");

export function applyAccent(hex) {
  const st = document.documentElement.style;
  if (hex) st.setProperty("--accent-ink", inkFor(hex)); else st.removeProperty("--accent-ink");
  Object.entries(STEPS).forEach(([k, [toWhite, t]]) => {
    if (!hex) { st.removeProperty(`--violet-${k}`); return; }
    const target = toWhite ? 255 : 0;
    const c = rgbOf(hex).map((v) => Math.round(v + (target - v) * t));
    st.setProperty(`--violet-${k}`, c.join(" "));
  });
}

let wrldAccent = null;
export const getHqAccent = () => localStorage.getItem(HQ_KEY) || null;
export function rememberHqAccent(hex) { if (hex) localStorage.setItem(HQ_KEY, hex); else localStorage.removeItem(HQ_KEY); }
export function setWrldAccent(hex) { wrldAccent = hex || null; }
export function applyForRoute(isPublic) { applyAccent(isPublic ? wrldAccent : getHqAccent()); }
